import { useRouter } from 'next/router';
import Head from 'next/head';
import { getItunesAppUniversalLinkMetaTag, RENTER_APP_ID } from 'helpers/templateHelpers';
import getConfig from 'next/config';

const { RAILS_URL, BS_ENV } = getConfig().publicRuntimeConfig;

interface HomepageHeadProps {
  metaTitle: string;
  metaDescription: string;
  // This should be 1200 wide.
  previewImage: string;
}
const HomepageHead = ({ metaTitle, metaDescription, previewImage }: HomepageHeadProps) => {
  const router = useRouter();

  return (
    <Head>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} key="description" />

      {/* Facebook Open Graph tags */}
      <meta name="facebook-domain-verification" content="upbap294hagzwgwo7u18t9xz0pqlkb" />
      <meta property="og:url" content="https://boatsetter.com" key="og:url" />
      <meta property="og:title" content={metaTitle} key="og:title" />
      <meta property="og:description" content={metaDescription} key="og:description" />
      <meta property="og:type" content="website" key="og:type" />
      {/*
        For the og:image, use a high-quality image that is at least 1,200 x 630 pixels:
        https://www.conductor.com/academy/open-graph/#og-image
      */}
      <meta property="og:image" content={previewImage} key="og:image" />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
      <meta name="twitter:site" content="@Boatsetter" key="twitter:site" />
      <meta name="twitter:creator" content="@Boatsetter" key="twitter:creator" />
      <meta name="twitter:title" content={metaTitle} key="twitter:title" />
      <meta name="twitter:description" content={metaDescription} key="twitter:description" />
      {/*
        The optimal size for an X (Twitter) post image is 1024 x 732 pixels:
        https://www.figma.com/resource-library/social-media/twitter-banner-size/
      */}
      <meta name="twitter:image" content={previewImage} key="twitter:image" />

      {getItunesAppUniversalLinkMetaTag(router.asPath, RENTER_APP_ID)}

      {BS_ENV !== 'development' && <link rel="canonical" href={RAILS_URL} key="canonical" />}
    </Head>
  );
};

export default HomepageHead;
